module.exports = __webpack_public_path__ + "img/megaphone-fill.ed4db242.svg";